import {Card, CardContent, Stack, Typography} from '@mui/material';
import {ExamModule} from '@cp/model';
import {env} from '../../config/env';
import mapModuleTopicToTopicString from '../../utils/map/mapModuleTopicToTopicString';
import mapModuleTopicToTopicId from '../TopicSelection/map/mapModuleTopicToTopicId';
import {QuestionFiltersSettings} from './QuestionFiltersSettings';

export interface QuestionFilterDisplayProps {
  filters: QuestionFiltersSettings;
  examModules: ExamModule[];
}

export default function QuestionFilterDisplay({filters, examModules}: QuestionFilterDisplayProps) {
  if (!filters.moduleId) return null;

  const selectedModule = examModules.find((module) => module.id === filters.moduleId);

  return (
    <Card sx={{mb: 3}}>
      <CardContent>
        <Typography variant="h6" sx={{color: '#1B263B', mb: 2}}>
          Active Filters
        </Typography>
        <Stack spacing={1}>
          {selectedModule && (
            <Typography variant="body2">
              <strong>Module:</strong> {selectedModule.name}
            </Typography>
          )}
          {filters.topic && selectedModule && (
            <Typography variant="body2">
              <strong>Topic:</strong>{' '}
              {(() => {
                const topic = selectedModule.topics.find((t) => mapModuleTopicToTopicId(t) === filters.topic);
                return topic ? mapModuleTopicToTopicString(topic, {spacer: ' • '}) : filters.topic;
              })()}
            </Typography>
          )}
          {filters.difficulty !== undefined && (
            <Typography variant="body2">
              <strong>Difficulty:</strong> {filters.difficulty} - {env.difficulty[filters.difficulty].label}
            </Typography>
          )}
          {filters.status && (
            <Typography variant="body2">
              <strong>Status:</strong> {env.question.status[filters.status]?.label || env.question.unknownStatus.label}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
